import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isNil from "lodash/isNil";
import _forEach from "lodash/forEach";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
import 'highlight.js/styles/nord.css';
import './index.scss';
import React from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Try `npm install @types/react-highlight` if it exi... Remove this comment to see the full error message
import Highlight from 'react-highlight/lib/optimized';
import xss, { whiteList } from 'xss';

// languages that are aliases for any of these are also supported
// (e.g. html is an alias of xml)
// only module names of highlight.js can be listed to make webpack work
import { jsx as ___EmotionJSX } from "@emotion/react";
export const highlightLanguages = ['python', 'r', 'sql', 'xml', 'scala', 'bash', 'json', 'shell', 'yaml', 'julia'];
const defaultProps = {
  className: '',
  customTag: 'div',
  extraClass: '',
  mathJaxEnabled: false,
  syntaxHighlighting: false,
  unsafe: false
};
const MAX_MATHJAX_WAIT_TIME = 10000; // 10seconds

let loaderSingleton;
function waitForMathJax() {
  if (loaderSingleton) {
    return loaderSingleton;
  }
  loaderSingleton = new Promise(resolve => {
    const start = Date.now();
    function checkMathJax() {
      var _MathJax$startup;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'MathJax' does not exist on type 'Window ... Remove this comment to see the full error message
      const {
        MathJax
      } = window;
      const isTimedOut = Date.now() - start > MAX_MATHJAX_WAIT_TIME;
      if (MathJax !== null && MathJax !== void 0 && (_MathJax$startup = MathJax.startup) !== null && _MathJax$startup !== void 0 && _MathJax$startup.promise) {
        resolve(MathJax.startup.promise);
        return;
      }
      if (!isTimedOut) {
        setTimeout(checkMathJax, 100);
        return;
      }
      if ("production" === 'test') {
        // Ideally we wouldn't relly on a global MathJax so tests could work,
        // but for now we just handle it by silencing the timeout error
        resolve();
        return;
      }
      throw new Error('Timed out waiting for a MathJax instance to be globally exposed.');
    }
    checkMathJax();
  });
  return loaderSingleton;
}
function isLightbox(el) {
  return el.id.match(/dc-lightbox-image-\d+-(open|close)/);
}
class HTMLContent extends React.PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "ref", void 0);
    this.ref = React.createRef();
  }
  componentDidMount() {
    this.renderMathJax();
    this.setLinksAttributes();
  }
  componentDidUpdate() {
    this.renderMathJax();
    this.setLinksAttributes();
  }
  setLinksAttributes() {
    if (!_isNil(this.ref.current)) {
      _forEach(this.ref.current.getElementsByTagName('a'), el => {
        if (isLightbox(el)) {
          return;
        }
        el.setAttribute('target', '_blank');
        el.setAttribute('rel', 'noopener noreferrer');
      });
    }
  }
  renderMathJax() {
    const {
      mathJaxEnabled
    } = this.props;
    if (!mathJaxEnabled) {
      return;
    }

    // We don't handle errors here to let them be unhandled rejections
    // in applications that consume le-shared-components
    waitForMathJax().then(() => {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'MathJax' does not exist on type 'Window ... Remove this comment to see the full error message
      const {
        MathJax
      } = window;
      if (!MathJax || _isNil(this.ref.current)) {
        return;
      }

      // typesetPromise is only available once MathJax loaded
      MathJax.typesetPromise([this.ref.current]);
    });
  }
  render() {
    const {
      customTag: Tag,
      extraClass,
      html,
      syntaxHighlighting,
      unsafe
    } = this.props;
    const content = unsafe ? html : xss(html, {
      stripIgnoreTag: true,
      stripIgnoreTagBody: true,
      whiteList: _objectSpread(_objectSpread({}, whiteList), {}, {
        summary: []
      })
    });
    if (syntaxHighlighting) {
      return ___EmotionJSX(Tag, {
        className: extraClass,
        ref: this.ref
      }, ___EmotionJSX(Highlight, {
        className: "dc-html-content-syntax-highlight",
        innerHTML: true,
        languages: highlightLanguages
      }, content));
    }
    return ___EmotionJSX(Tag, {
      className: extraClass,
      dangerouslySetInnerHTML: {
        __html: content
      },
      ref: this.ref
    });
  }
}
_defineProperty(HTMLContent, "defaultProps", defaultProps);
export default HTMLContent;